import type { ProgramFile } from '@/modules/Entertainment/interface/Program';
import { type FC } from 'react';
import { Flex, Text } from '@eqi-investimentos/react';
import { useT } from '@/libs/i18n/utils/useT';
import { SupplementaryMaterialCard } from '@/modules/Research/ui/SupplementaryMaterials/Card';
import { MapRender } from '@/utils/jsx';

export const MaterialSection: FC<MaterialSectionProps> = ({ programFiles }) => {
  const i18n = useT();

  return (
    <Flex id="material-complementar" flexDir="column" gap="l">
      <Text size="2xl">
        {i18n('screens.researchProgram.supplementary.title')}
      </Text>

      <Flex flexWrap="wrap" gap="8" w="full">
        <MapRender
          items={programFiles}
          render={(file) => (
            <SupplementaryMaterialCard key={file.id} {...file} />
          )}
        />
      </Flex>
    </Flex>
  );
};

type MaterialSectionProps = {
  programFiles: ProgramFile[];
};
